import styled from "@emotion/styled"
import RoomIcon from "@mui/icons-material/Room"
import WhatsAppIcon from "@mui/icons-material/WhatsApp"
import { Link, Typography } from "@mui/material"
import * as api from "api"
import NextLink from "common/NextLink"
import PhoneIcon from "common/icons/PhoneIcon"
import slugify from "common/utils/slugify"
import nextLinks from "next.links"
import { memo } from "react"
import Shared from "theme/shared"

const Styled = {
  wrapper: styled.div`
    margin: 0 15px;
    padding: 20px 0;
    border-bottom: 1.5px solid ${(p) => p.theme.colors.silver};

    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 0;
      padding: 20px 25px;
    }
  `,
  Headline: styled(Typography)`
    color: ${(p) => p.theme.colors.duskBlue};
    margin-top: 0;
    display: inline-block;
  `,
  Content: styled.div`
    display: flex;
    font-size: 1rem;
    color: ${(p) => p.theme.colors.marine};
    padding: 3px 0;
  `,
  ContentHeadline: styled.div`
    width: 100px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    svg {
      font-size: 0.925em;
      color: ${(p) => p.theme.colors.bluishGrey};
      margin-inline-end: 10px;
      g {
        fill: ${(p) => p.theme.colors.bluishGrey};
      }
    }
  `,
  ContentValue: styled.div``,
  Link: styled(Link)`
    color: ${(p) => p.theme.colors.marine} !important;
    text-decoration: underline;
    cursor: pointer;

    > h2 {
      text-decoration: underline;
    }
  `,
  WazeButton: styled(Shared.Button)`
    height: 35px;
    font-size: 14px;
    margin-top: 15px;
  `,
  Waze: styled.img`
    width: 25px;
    height: 23px;
    margin-inline-end: 6px;
  `,
}

type ServiceCenterItemProps = { center: api.ServiceCenter }

const ServiceCenterItem = ({ center }: ServiceCenterItemProps) => {
  const link = nextLinks.serviceCenter
    .replace("[serviceCenterId]", center.id.toString())
    .replace("[serviceCenterSlug]", slugify(center.name))

  return (
    <Styled.wrapper>
      {center.isActive ? (
        <NextLink href={link} passHref>
          <Styled.Link href={link} title={`מעבר למרכז השירות ${center.name}`}>
            <Styled.Headline variant="h2">{center.name}</Styled.Headline>
          </Styled.Link>
        </NextLink>
      ) : (
        <Styled.Headline variant="h2">{center.name}</Styled.Headline>
      )}

      <Styled.Content>
        <Styled.ContentHeadline>
          <RoomIcon />
          כתובת
        </Styled.ContentHeadline>
        <Styled.ContentValue>{center.address}</Styled.ContentValue>
      </Styled.Content>

      <Styled.Content>
        <Styled.ContentHeadline>
          <PhoneIcon />
          טלפון
        </Styled.ContentHeadline>
        <Styled.ContentValue>
          <Styled.Link href={`tel:${center.phone}`}>{center.phone}</Styled.Link>
        </Styled.ContentValue>
      </Styled.Content>

      {center.whatsappLink && (
        <Styled.Content>
          <Styled.ContentHeadline>
            <WhatsAppIcon />
            וואטסאפ
          </Styled.ContentHeadline>
          <Styled.ContentValue>
            <Styled.Link
              href={center.whatsappLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              {center.whatsapp}
            </Styled.Link>
          </Styled.ContentValue>
        </Styled.Content>
      )}
      <Shared.Mobile>
        {center.wazeLink && (
          <Styled.WazeButton variant="contained" href={center.wazeLink}>
            <Styled.Waze src="/waze.png"></Styled.Waze>
            נווט
          </Styled.WazeButton>
        )}
      </Shared.Mobile>
    </Styled.wrapper>
  )
}

export default memo(ServiceCenterItem)
